import React, { useEffect } from "react";
// import objectPath from "object-path";
import ApexCharts from "apexcharts";
// import {useHtmlClassService} from "../../../../_metronic/layout";
// import {KTUtil} from '../../../../_metronic/_assets/js/components/util';

const numberFormatter = new Intl.NumberFormat();
const currentYr = new Date().getFullYear();

export function TransactionCount({ className, data }) {
  
  // const uiService = useHtmlClassService();

  // const layoutProps = useMemo(() => {
    
  //   return {
  //     colorsGrayGray100: objectPath.get(uiService.config, "js.colors.gray.gray100"),
  //     colorsGrayGray700: objectPath.get(uiService.config, "js.colors.gray.gray700"),
  //     colorsThemeBaseSuccess: objectPath.get(
  //         uiService.config,
  //         "js.colors.theme.base.success"
  //     ),
  //     colorsThemeLightSuccess: objectPath.get(
  //         uiService.config,
  //         "js.colors.theme.light.success"
  //     ),
  //     fontFamily: objectPath.get(uiService.config, "js.fontFamily")
  //   };
  // }, [uiService]);

  useEffect(() => {

    if(Array.isArray(data) && data.length === 0){
      return;
    }
    
    const tranxChart = document.getElementById("transaction_count_per_month");
    const year = new Date().getFullYear();
    
    let tranxData = data.filter( tx => tx.year === `${year}`);
    let tranxSum = 0;
    tranxData.forEach(tx => { tranxSum = tranxSum + tx.transactions });

    tranxData = tranxData.sort((a, b) => {
      return a.month_digit - b.month_digit;
    });

    let months = tranxData.map(tx => ( tx.month_name.substring(0, 3)));
    let tranx = tranxData.map(tx => tx.transactions);
    
    const options = getChartOptions(tranx, months, tranxSum);
    
    const chart = new ApexCharts(tranxChart, options);
    chart.render();

    return function(){
      chart.destroy();
    };

  }, [data]);

  const getChartOptions = (tranx, months, totalTranx) => {
    const options = {
      chart: {
        id: 'transaction_count_per_month',
        type: 'area',
        height: 300,
        toolbar: {
          show: false
        },
      },
      stroke: {
        curve: 'straight'
      },
      fill: {
        opacity: 1,
      },
      series: [
        {
          name: 'Transaction Count',
          data: tranx
        }
      ],
      labels: months,
      xaxis: {
        type: 'category',
        show: true,
      },
      yaxis: {
        show: false,
        min: 0,
      },
      colors: ['#5564BE'],
      title: {
        text: numberFormatter.format(totalTranx),
        offsetX: 30,
        style: {
          fontSize: '30px',
          fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`,
          cssClass: 'apexcharts-yaxis-title'
        }
      },
      subtitle: {
        text: `Total Transactions, ${currentYr}`,
        offsetY: 50,
        offsetX: 30,
        style: {
          fontSize: '18px',
          fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`,
          cssClass: 'apexcharts-yaxis-title'
        }
      }
    };
    
    return options;
  };


  return (
    <div className={`card card-custom ${className}`}>

      {/* Header */}
      <div className="card-header border-0 pt-5">
        <h3 className="card-title font-weight-bolder ">Transactions Count Per Month</h3>
        <div className="card-toolbar">

        </div>
      </div>

      {/* Body */}
      <div className="card-body d-flex flex-column">
        <div className="flex-grow-1">
          <div id="transaction_count_per_month" style={{height: "200px"}}></div>
        </div>
        {/* <div className="pt-5">
          <p className="text-center font-weight-normal font-size-lg pb-7">
            Notes: Current sprint requires stakeholders<br/>
            to approve newly amended policies
          </p>
          <a href="#" className="btn btn-success btn-shadow-hover font-weight-bolder w-100 py-3">Generate Report</a>
        </div> */}
      </div>
    </div>
  );
}

// var randomizeArray = function (arg) {
//   var array = arg.slice();
//   var currentIndex = array.length, temporaryValue, randomIndex;

//   while (0 !== currentIndex) {

//     randomIndex = Math.floor(Math.random() * currentIndex);
//     currentIndex -= 1;

//     temporaryValue = array[currentIndex];
//     array[currentIndex] = array[randomIndex];
//     array[randomIndex] = temporaryValue;
//   }

//   return array;
// }

// var sparklineData = [47, 45, 54, 38, 56, 24, 65, 31, 37, 39, 62, 51];
// var sparklineData = [47, 45, 54, 38, 56, 24, 65, 31, 37, 39, 62, 51, 35, 41, 35, 27, 93, 53, 61, 27, 54, 43, 19, 46];
